import { PaintedScene } from '../PaintedScene';

export const HOLLOW_LOG_BRIDGE_PHASER_KEY = 'HollowLogBridgeScene' as const;
export const HOLLOW_LOG_BRIDGE_MANIFEST_KEY = 's-412-hollow-log-bridge' as const;

export class HollowLogBridgeScene extends PaintedScene {
  constructor() {
    super(HOLLOW_LOG_BRIDGE_PHASER_KEY, HOLLOW_LOG_BRIDGE_MANIFEST_KEY);
  }
}
